import { Box, Stack, Typography } from '@mui/material'
import { partition, pluck, uniq } from 'ramda'
import { useAllRequirements } from '../../hooks'
import { DetailTemplateField } from './DetailTemplateField'

export const YearlessDetailsForm = () => {
  const requirements = useAllRequirements()

  if (requirements.isLoading) {
    return null
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [yearlyRequirements, yearlessRequirements] = partition(
    ({ year }) => !!year && year !== -1,
    requirements.data
  )

  const yearlessTraits = uniq(pluck('traitId', yearlessRequirements)).filter(d => d !== 'geometry')

  return (
    <Box>
      {yearlessTraits.map(traitId => (
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          spacing={1}
          key={traitId}
        >
          <Typography>{traitId}</Typography> <DetailTemplateField fullWidth traitId={traitId} />
        </Stack>
      ))}
    </Box>
  )
}
